var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoSemi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.5V9C16 10.1046 16.8954 11 18 11H22.5M1 19L21 19M9.4 19V16M3.4 19L3.4 16M14.4 19V16M19.4 19V16M5 5H15.7487C16.8651 5 17.9307 5.46655 18.6879 6.28688L22.5187 10.4369C23.1043 11.0713 23.2167 12.01 22.7974 12.7647L21.2858 15.4856C21.1094 15.8031 20.7748 16 20.4116 16H2.5C1.94771 16 1.5 15.5523 1.5 15V6C1.5 5.44771 1.94772 5 2.5 5H5ZM1.5 11H3C3.55228 11 4 10.5522 4 9.99994C4 9.5165 4 9.0835 4 8.60006C4 8.04777 3.55142 7.6 2.99913 7.6C2.59631 7.6 2.78454 7.6 1.5 7.6V11ZM6.5 8.6V10C6.5 10.5523 6.94772 11 7.5 11H11C11.5523 11 12 10.5522 12 9.99994C12 9.5165 12 9.0835 12 8.60006C12 8.04777 11.5523 7.6 11 7.6C9.83333 7.6 8.66667 7.6 7.5 7.6C6.94772 7.6 6.5 8.04771 6.5 8.6Z",
    stroke: "#E98943",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSemi);
export default __webpack_public_path__ + "static/media/ico-semi.81227246cafa75903f53fd552c53e0d1.svg";
export { ForwardRef as ReactComponent };